module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAMCAgMCAgMDAwMEAwMEBQgFBQQEBQoHBwYIDAoMDAsKCwsNDhIQDQ4RDgsLEBYQERMUFRUVDA8XGBYUGBIUFRT/wgALCAAgACABAREA/8QAGAABAQEBAQAAAAAAAAAAAAAAAggDAAn/2gAIAQEAAAAA9U84oFtCLhztFxK7X0//xAAlEAABAwEHBQEAAAAAAAAAAAADAAECExAiMjNCcpIjUVJTsQT/2gAIAQEAAT8AR8gm10bNJuf69lcfnHkyMcbhJfjhfUyKElUnTnifS/d1RJ658XVYnsnydBMSrDqTxNqfugAG4YXI4W0sqA/CPFrAZsNzfV+fIhtaz//Z"


//////////////////
// WEBPACK FOOTER
// ./src/components/PageTemplate/images/transparentBg.jpg
// module id = 278
// module chunks = 0